import { Injectable } from "@angular/core";
import { ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd, PRIMARY_OUTLET, Router } from "@angular/router";
import { LocalStorageService } from "../../edtell-caching/services/local-storage.service";
import { filter, map } from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
    export class RouteVisitedService {
    
    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private localStorageService: LocalStorageService
    ) {
        // on route change, get current activated route, and see if it has the data property to track route visited
        // copy/pasted from routerDataService
        this.router.events
        .pipe(filter((event) => event instanceof NavigationEnd))
        .pipe(map(() => this.route))
        .pipe(filter((route) => route.outlet === PRIMARY_OUTLET))
        .subscribe(async (route) => {
            let currentRoute = route;
            // get the deepest child route, as that is where we are!
            while (currentRoute.firstChild) {
                currentRoute = currentRoute.firstChild;
            }
            if (currentRoute.snapshot.data.trackRouteVisited) {
                this.setRouteVisited(currentRoute)
            }
        });

    }
    
    setRouteVisited(route: ActivatedRoute) {
        let path = this.getResolvedUrl(route.snapshot);

        let visitedPaths = this.localStorageService.getLocalStorageItem('visitedPaths');
        let visitedPathsList = [];

        if (visitedPaths != null) {
            visitedPathsList = JSON.parse(visitedPaths);
        }
    
        if(visitedPathsList.includes(path)) {
            return; // short circuit
        }
    
        visitedPathsList.push(path);
    
        this.localStorageService.setLocalStorageItem(
            'visitedPaths',
            JSON.stringify(visitedPathsList),
            1000 * 60 * 60 * 24 * 2 // 2 days
        );
    }
    
    
    // https://stackoverflow.com/questions/50250361/how-to-elegantly-get-full-url-from-the-activatedroutesnapshot
    getResolvedUrl(route: ActivatedRouteSnapshot): string {
        return '/' + route.pathFromRoot
        .map((v) => v.url.map((segment) => segment.toString()).join("/")).filter((v) => v !== "")
        .join("/");
    }

}